export const CameraOffIcon = () => {
  return (
    <div style={{ display: 'flex' }}>
      <svg width="20" height="14" viewBox="0 0 19 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.432 4.88013C14.4403 4.93191 14.4403 4.99109 14.432 5.04287C14.432 4.99109 14.4236 4.93931 14.4236 4.88753L14.432 4.88013Z"
          fill="black"
        />
        <path
          d="M14.0457 4.13301L2.77691 14.0823C1.60394 13.424 1.14314 12.2478 1.14314 11.116V5.19821C1.14314 2.66835 2.25745 1.68452 5.12283 1.68452H10.1498C12.5711 1.68452 13.7357 2.38725 14.0457 4.13301Z"
          fill="black"
        />
        <path
          d="M17.4984 0.929256C17.2471 0.707338 16.8365 0.707338 16.5852 0.929256L1.11884 14.5846C0.867491 14.8065 0.867491 15.169 1.11884 15.3909C1.24451 15.4944 1.41208 15.5536 1.57127 15.5536C1.73883 15.5536 1.89802 15.4944 2.0237 15.3835L17.4984 1.72816C17.7498 1.50624 17.7498 1.15117 17.4984 0.929256ZM18.3195 5.47931V10.8349C18.3195 11.8927 17.733 12.3144 17.3979 12.4697C17.2387 12.5437 16.9873 12.6251 16.6773 12.6251C16.3171 12.6251 15.873 12.5215 15.3536 12.196L14.1136 11.4267C14.0549 13.0615 13.4685 13.9935 12.1363 14.3856C11.6001 14.5557 10.9382 14.6297 10.1423 14.6297H5.11529C4.91421 14.6297 4.72151 14.6223 4.52043 14.6001L16.87 3.70397C17.0879 3.71876 17.2638 3.77794 17.3979 3.84451C17.733 3.99986 18.3195 4.4215 18.3195 5.47931Z"
          fill="black"
        />
      </svg>
    </div>
  );
};
